import { get } from './client';

/**
 * 
 * @param {*} id 
 * @returns 
 */
export function getOneWhiteLabel(id) {
    return get('whitelabel/' + id)
}
